import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.css']
})
export class InputCheckboxComponent implements OnInit, OnChanges {
  _isChecked = false;
  _isDisabled = false;

  @Input()
  label: string;

  @Input()
  name: string;

  @Input()
  isDisabled = false;

  @Input()
  tooltip = null;

  @Input()
  isChecked = false;

  @Input()
  isRadio = false;

  @Output()
  isCheckedChange = new EventEmitter<boolean>();

  // tslint:disable-next-line
  @Output()
   onChecked = new EventEmitter<boolean>();

  _onChecked(val: any) {
    this.isChecked = val.target.checked;
    this._isChecked = this.isChecked;
    this.isCheckedChange.emit(this._isChecked);
    this.onChecked.emit(this._isChecked);
    this._isDisabled = this.isDisabled;
  }

  ngOnChanges(changes: any): void {
    this._isChecked = this.isChecked;
    this._isDisabled = this.isDisabled;
  }

  ngOnInit(): void {

  }

}
